import { createTheme } from "@mui/material/styles";
// Añade los tipos de MuiDataGrid a "components" del tema
import "@mui/x-data-grid/themeAugmentation";

// Paleta oficial de AEDAS (aedas-library). Las mismas variables están
// en index.css para los estilos que no pasan por MUI.
export const aedas = {
  primary: "#041c2c",
  primaryLight: "#234158",
  black: "#1f2020",
  white: "#f9fafa",
  grey: "#bbbcbc",
  lightgrey: "#dedfdf",
  greyHover: "#eceded",
  lightblue: "#0088a6",
  green: "#00b176",
  greenDark: "#037951",
  orange: "#ff7f32",
  yellow: "#ffcc43",
  red: "#a53b24",
  detailText: "#5f6060",
  background: "#f4f5f5",
};

export const primaryFont = '"lis-title", sans-serif';
export const secondaryFont = '"lis-body", sans-serif';

export const theme = createTheme({
  palette: {
    primary: { main: aedas.primary, light: aedas.primaryLight, contrastText: aedas.white },
    secondary: { main: aedas.lightblue, contrastText: aedas.white },
    info: { main: aedas.lightblue, contrastText: aedas.white },
    success: { main: aedas.green, dark: aedas.greenDark, contrastText: aedas.white },
    warning: { main: aedas.orange, contrastText: aedas.white },
    error: { main: aedas.red, contrastText: aedas.white },
    text: { primary: aedas.black, secondary: aedas.detailText },
    background: { default: aedas.background, paper: aedas.white },
    divider: aedas.lightgrey,
    action: { hover: aedas.greyHover },
  },
  typography: {
    fontFamily: primaryFont,
  },
  components: {
    // Mismo estilo que AedasButton
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontFamily: primaryFont,
          fontSize: 14,
          fontWeight: 600,
          lineHeight: 1,
          textTransform: "capitalize",
          borderRadius: 4,
          padding: "9px 16px",
        },
        sizeSmall: {
          fontSize: 13,
          padding: "6px 12px",
        },
        containedPrimary: {
          "&:hover": { backgroundColor: aedas.primaryLight },
        },
        textPrimary: {
          "&:hover": { color: aedas.primaryLight, backgroundColor: "transparent" },
        },
      },
    },
    // Mismo estilo que AedasChips: relleno sólido, texto blanco en negrita
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: primaryFont,
          fontWeight: 600,
          borderRadius: 20,
        },
        filled: {
          "&.MuiChip-colorDefault": {
            backgroundColor: aedas.grey,
            color: aedas.white,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": { borderColor: aedas.grey },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: aedas.detailText },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: aedas.lightblue },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": { color: aedas.lightblue },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { backgroundColor: aedas.lightgrey, borderRadius: 4 },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          fontFamily: primaryFont,
          backgroundColor: aedas.white,
          borderColor: aedas.lightgrey,
          "& .MuiDataGrid-row:hover, & .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: aedas.greyHover,
          },
          "& .MuiDataGrid-columnHeader--alignLeft .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "flex-start",
          },
          "& .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "flex-end",
          },
        },
        columnHeaders: {
          backgroundColor: aedas.primary,
          color: aedas.white,
          "& .MuiSvgIcon-root": { color: aedas.white },
        },
        // Centrado por defecto; headerAlign "left"/"right" se aplica en root
        columnHeaderTitleContainer: {
          justifyContent: "center",
        },
        columnHeaderTitle: {
          fontWeight: 700,
        },
        // Centrado por defecto. Para alinear a la izquierda usar alignLeft
        // (TableActions.tsx), porque la grid marca todas las celdas como textLeft
        cell: {
          justifyContent: "center",
          borderColor: aedas.lightgrey,
          "&.MuiDataGrid-cell--textRight": { justifyContent: "flex-end" },
          "&.aedasCell--left": { justifyContent: "flex-start" },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: { minHeight: 40, borderBottom: `1px solid ${aedas.lightgrey}` },
        indicator: { backgroundColor: aedas.lightblue },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 40,
          fontFamily: primaryFont,
          fontSize: 14,
          fontWeight: 600,
          textTransform: "capitalize",
          color: aedas.detailText,
          "&.Mui-selected": { color: aedas.primary },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: { marginBottom: 0 },
        displayedRows: { marginBottom: 0 },
      },
    },
  },
});
